/**
 * The warning bar — the generator's `renderWarnings`.
 *
 * Warnings are strings produced by the shared `buildModel`: pillar weightings
 * that do not sum to 100%, rooms with no pillars, unrecognised deliverable
 * states. They are rendered as text, never as HTML — the generator escaped them
 * by hand with `esc()`, and React does it by construction.
 *
 * Text selection is deliberately ENABLED here. The ported CSS re-enables it for
 * `.warnbar`, the status line and the timeline notes, and nowhere else, because
 * a warning is the one thing on this page a user genuinely wants to copy.
 */
export function WarningBar({ warnings }: { warnings: string[] }) {
  if (!warnings.length) return null;

  return (
    <div className="warnbar show" role="status">
      <b>{warnings.length} thing(s) to check:</b>
      <ul>
        {warnings.map((w, i) => (
          <li key={i}>{w}</li>
        ))}
      </ul>
    </div>
  );
}
